export const baseUrl = 'idvalidation';

import { host } from '../plugins/api/api';

export const baseEndpointUrl = `${host}/${baseUrl}/`;

/**
 * @private
 */
export const API_ENDPOINTS = {
  getClientData: 'client/requiredData',
  putClientData: 'client/requiredData',
  getUpdateInitialData: (countryCode: string) => `e1${countryCode ? `/${countryCode}` : ''}`,
  getValidateBooking: 'b0/{{bookingId}}/{{email}}/{{bookingDate}}/{{locale}}',
  getAddress: 'd0/client/address',
  getProvinces: 'provinces/{{countryCode}}',
  getCities: 'cargos-cities',
  postOnfidoData: 'jwt',
  postScannedDocument: 'e2',
  putDocumentsChecksIds: 'e3',
  postCheckpoint: 'l0',
  putUpdateAddress: 'd0',
  countries: (locale: string) => `country?locale=${locale}`,
} as const;
